import { registerEntityEndpoint as e } from "@editor/ui-utils";
//#region ../../../framework/utils/brands/dist/brandEnums.js
var t;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.FITFORFUN = "fitforfun", e.FINANZEN100 = "finanzen100", e.MITTIER = "mittier", e.MITSTERNEN = "mitsternen", e.MITBEZIEHUNG = "mitbeziehung", e.TVTODAY = "tvtoday", e.TVSPIELFILM = "tvspielfilm";
})(t ||= {}), Object.freeze(t);
var n;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.PRAXISTIPPS = "praxistipps";
})(n ||= {}), Object.freeze(n), Object.freeze([
	t.MITTIER,
	t.MITSTERNEN,
	t.MITBEZIEHUNG,
	t.TVTODAY,
	t.TVSPIELFILM
]), Object.freeze({
	[t.BUNTE]: "bunte",
	[t.CHIP]: "chip",
	[t.FOCUS]: "focus",
	[t.FITFORFUN]: "fitforfun",
	[t.FINANZEN100]: "finanzen100",
	[t.MITTIER]: "default-verticals",
	[t.MITSTERNEN]: "default-verticals",
	[t.MITBEZIEHUNG]: "default-verticals",
	[t.TVTODAY]: "default",
	[t.TVSPIELFILM]: "default"
}), Object.freeze(Object.values(t)), Object.freeze(Object.values(n)), t.BUNTE, t.CHIP, t.FOCUS, t.FITFORFUN, t.TVSPIELFILM, t.TVTODAY, t.BUNTE, t.CHIP, t.FOCUS, t.FITFORFUN, t.TVSPIELFILM, t.TVTODAY;
//#endregion
//#region ../../../framework/ctf-config/dist/generalEnums.js
var r;
(function(e) {
	e.LOCAL = "local", e.LOCAL_K8S = "local_k8s", e.LOCAL_E2E = "local_e2e", e.SANDBOX = "sandbox", e.DEVELOPMENT = "development", e.STAGING = "staging", e.PRODUCTION = "production", e.TEST = "test";
})(r ||= {});
//#endregion
//#region ../../../framework/ctf-config/dist/configHelper.js
function i(e) {
	return a(e);
}
function a(e) {
	return Object.getOwnPropertyNames(e).forEach((t) => {
		let n = e[t];
		n && (typeof n == "object" || typeof n == "function") && !Object.isFrozen(n) && a(n);
	}), Object.freeze(e);
}
function o(e, t) {
	let n = {};
	for (let r in {
		...t,
		...e
	}) if (typeof t[r] == "object" && !Array.isArray(t[r]) && t[r] !== null && e && r in e) {
		let i = e[r], a = t[r];
		n[r] = o(i, a);
	} else e && r in e && typeof e[r] == "function" ? n[r] = e[r].bind(n) : typeof t[r] == "function" ? n[r] = t[r].bind(n) : e && r in e ? n[r] = e[r] : n[r] = t[r];
	return n;
}
function s(e) {
	return Object.values(r).find((t) => t === e) !== void 0;
}
function c() {
	let e = process.env.APP_ENV;
	if (e === void 0) throw Error("APP_ENV is undefined.\nHint: configuration should be initialized lazily during runtime and not during build time.");
	if (!s(e)) throw Error(`APP_ENV=${e}. Allowed values=${Object.values(r).join(", ")}`);
	return e;
}
var l = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap();
function d(e, t) {
	let n = l.get(e), r = n?.get(t);
	if (r !== void 0) return r;
	let { base: a, ...s } = e, d;
	d = typeof process > "u" ? s.local : s[c()];
	let f = u.get(e);
	f === void 0 && (f = d ? o(d, a) : a, u.set(e, f));
	let { _: p, ...m } = f, h = m[t], g = i(h ? o(h, p) : p);
	return n || (n = /* @__PURE__ */ new Map(), l.set(e, n)), n.set(t, g), g;
}
function f(e) {
	return e ? Object.values(t).find((t) => t === e) : void 0;
}
function p(e) {
	let t = f(e);
	if (!t) throw Error("invalid brand!");
	return t;
}
//#endregion
//#region ../../../framework/ctf-config/dist/configs/cwc.config.js
var m = {
	base: {
		_: {
			cwcUrl: "https://widget-stg.chip.de/",
			account: "chip",
			pimDownloadDetailsUrl: "https://admin.bestcheck.bf-bestcheck-production.aws.bfops.io/admin#/sw/extension/module/BcAdminIntegrationApp/downloads_product/detail/"
		},
		bunte: {
			cwcUrl: "https://widget-stg.bunte.de/",
			account: "bunte"
		},
		chip: {
			cwcUrl: "https://widget-stg.chip.de/",
			account: "chip"
		},
		focus: {
			cwcUrl: "https://widget-stg.focus.de/",
			account: "focus-online"
		},
		fitforfun: {
			cwcUrl: "https://widget-stg.fitforfun.de/",
			account: "fitforfun"
		},
		finanzen100: {
			cwcUrl: "https://widget-stg.finanzen100.de/",
			account: "finanzen100"
		}
	},
	local: {
		_: { cwcUrl: "https://widget-local.chip.de:8002/" },
		bunte: { cwcUrl: "https://widget-local.bunte.de:8002/" },
		chip: { cwcUrl: "https://widget-local.chip.de:8002/" },
		focus: { cwcUrl: "https://widget-local.focus.de:8002/" },
		fitforfun: { cwcUrl: "https://widget-local.fitforfun.de:8002/" },
		finanzen100: { cwcUrl: "https://widget-local.finanzen100.de:8002/" }
	},
	local_k8s: {
		_: { cwcUrl: "https://widget-local.chip.de:8002/" },
		bunte: { cwcUrl: "https://widget-local.bunte.de:8002/" },
		chip: { cwcUrl: "https://widget-local.chip.de:8002/" },
		focus: { cwcUrl: "https://widget-local.focus.de:8002/" },
		fitforfun: { cwcUrl: "https://widget-local.fitforfun.de:8002/" },
		finanzen100: { cwcUrl: "https://widget-local.finanzen100.de:8002/" }
	},
	sandbox: {
		_: { cwcUrl: "https://widget-sandbox.chip.de/" },
		bunte: { cwcUrl: "https://widget-sandbox.chip.de/" },
		chip: { cwcUrl: "https://widget-sandbox.chip.de/" },
		focus: { cwcUrl: "https://widget-sandbox.chip.de/" },
		fitforfun: { cwcUrl: "https://widget-sandbox.chip.de/" },
		finanzen100: { cwcUrl: "https://widget-sandbox.chip.de/" }
	},
	development: {
		_: { cwcUrl: "https://widget-dev.chip.de/" },
		bunte: { cwcUrl: "https://widget-dev.chip.de/" },
		chip: { cwcUrl: "https://widget-dev.chip.de/" },
		focus: { cwcUrl: "https://widget-dev.chip.de/" },
		fitforfun: { cwcUrl: "https://widget-dev.chip.de/" },
		finanzen100: { cwcUrl: "https://widget-dev.chip.de/" }
	},
	production: {
		_: { cwcUrl: "https://widget.chip.de/" },
		bunte: { cwcUrl: "https://widget.bunte.de/" },
		chip: { cwcUrl: "https://widget.chip.de/" },
		focus: { cwcUrl: "https://widget.focus.de/" },
		fitforfun: { cwcUrl: "https://widget.fitforfun.de/" },
		finanzen100: { cwcUrl: "https://widget.finanzen100.de/" }
	}
}, h = (e) => d(m, e), g = e("cwc-widget"), { getEntity: _, getEntityAPIClient: v } = g, y = v(), b = (e) => {
	let t = {
		_id: e._id,
		title: e.title,
		widgetType: e.widgetType,
		cwcId: e.cwcId
	};
	return e.widgetData.type === "download-page" && (t.attributes = { downloadId: e.widgetData.settings.downloadId }), t;
}, x = async (e) => b(await _(e)), S = (e, t) => `${h(e).pimDownloadDetailsUrl}${t}`, C = (e, t) => S(p(e), t), w = async (e) => (await y.get("credentials", { params: { brand: e } })).data, T = () => ({
	_id: "",
	title: "",
	cwcId: "",
	widgetType: ""
});
function E() {
	return window.GLOBAL_CONFIG;
}
var D = () => [
	"pro-con-list",
	"chapter-label",
	"download-widget",
	"download-widget-pim",
	"ir-boost-list",
	"bestcheck",
	"top-list",
	"top-list-auto-table",
	"top-list-auto-table-ecar",
	"deal-widget",
	"table",
	"bestcheck-gallery",
	"advanced-boost-widget",
	"faq-box",
	"toplist-diagram-widget",
	"car-variant",
	"car-variant-leasing",
	"factbox",
	"events",
	"download-charts",
	"download-page"
];
//#endregion
export { T as a, b as c, w as i, C as n, E as o, D as r, x as s, g as t };

//# sourceMappingURL=cwc-widget.service-B1F6bdKV.js.map